import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Actions from 'modules/payroll_bundle/components/PageHeader/Actions'
import A3innuvaSyncDataButton from 'modules/payroll_bundle/components/PageHeader/PayrollA3innuvaSyncButton'
import ExportDataButton from 'modules/payroll_bundle/components/PageHeader/PayrollExportButton'
import UpsellContactButton from 'modules/payroll_bundle/components/PageHeader/UpsellContactButton'
import UpsellPromoModal from 'modules/payroll_bundle/components/PageHeader/UpsellPromoModal'
import { useMatchSupplementsUrl } from 'modules/payroll_bundle/hooks/useMatchPayrollUrls'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import useSupplementsActions from 'modules/payroll_bundle/pages/CyclesPage/Header/_NavigationActions/useSupplementsActions'
import PolicySelectors from 'modules/payroll_bundle/pages/SupplementsPage/_components/_PolicySelectors'

interface Props {
  policyId?: string
  periodId?: string
}

const CyclesPageSubHeader = ({ policyId, periodId }: Props) => {
  const { currentPeriodStatus } = usePolicyPeriods()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { canDownloadPayrollData } = usePayrollContextlessPolicies()

  const { action, options } = useSupplementsActions(navigate, navigation, currentPeriodStatus)
  const { canUpsellSeeActivationPromo } = usePayrollContextlessPolicies()
  const [showUpsellModal, setShowUpsellModal] = React.useState<boolean>(false)

  const isSupplementsPage = useMatchSupplementsUrl(policyId, periodId)
  const isExportDataVisible = canDownloadPayrollData && isSupplementsPage

  return (
    <Box flexDirection="row" flexNoShrink justifyContent="spaceBetween">
      <PolicySelectors />
      <Box flexDirection="row" gap="s8">
        {isExportDataVisible && <A3innuvaSyncDataButton />}
        {isExportDataVisible && <ExportDataButton />}

        {canUpsellSeeActivationPromo && (
          <UpsellContactButton onClick={() => setShowUpsellModal(true)} />
        )}
        {isSupplementsPage && <Actions action={action} options={options} />}
        {showUpsellModal && <UpsellPromoModal onClose={() => setShowUpsellModal(false)} />}
      </Box>
    </Box>
  )
}

export default CyclesPageSubHeader
